
define('template!webshopMenuHistoryView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="mm-modal-text">' +
((__t = ( _.i18n('webshop.menu.historyHelp', null, 'Each publication keeps a version. Select one and load it in the editor to compare or restore it.') )) == null ? '' : __t) +
'</div>\n<div class="mm-history-list">\n    <div class="mm-history-loading"><i class="fa fa-spinner fa-spin"></i></div>\n</div>\n';

}
return __p
};});

